import { cn } from '../../lib/cn'

type PillTone = 'neutral' | 'moss' | 'honey' | 'ink'

interface PillProps {
  tone?: PillTone
  children: React.ReactNode
  className?: string
}

const toneStyles: Record<PillTone, string> = {
  neutral: 'bg-chip text-chip-fg',
  moss: 'bg-moss-bg text-moss',
  honey: 'bg-honey-chip text-honey-fg',
  ink: 'bg-ink text-paper-panel',
}

/** Fully-rounded mono tag/chip. */
export function Pill({ tone = 'neutral', children, className }: PillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2 py-1 font-mono text-[11px]',
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
